export const TEST_ID = 'applicationActivityList';

export const START_STATUS = 'start';

export const COMPLETE_STATUS = 'complete';
